"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_scripts.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getArchiveModalSubtitle(archivedFilter, organisationName) {
  return _react.default.createElement("span", null, archivedFilter === 'ARCHIVED' ? 'Unarchiving this script will make this visible for everyone within ' : 'Archiving this script will make this hidden from view from everyone within ', _react.default.createElement("strong", null, organisationName), ".");
}

var MODAL = {
  DELETE: 'DELETE',
  ARCHIVE: 'ARCHIVE'
};
var LIST_FILTERS = {
  ARCHIVED_FILTER: [{
    label: 'Active',
    value: 'ACTIVE'
  }, {
    label: 'Archived',
    value: 'ARCHIVED'
  }]
};

var Scripts = /*#__PURE__*/function (_Component) {
  _inherits(Scripts, _Component);

  function Scripts(props) {
    var _this;

    _classCallCheck(this, Scripts);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Scripts).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleScriptAction", (0, _lodash.default)(function (_ref) {
      var actionRequest = _ref.actionRequest,
          scriptId = _ref.scriptId;
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _ref3, error;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return actionRequest(scriptId);

                case 3:
                  _ref3 = _context.sent;
                  error = _ref3.error;

                  if (!error) {
                    _context.next = 7;
                    break;
                  }

                  return _context.abrupt("return", void _this.setState({
                    error: error
                  }));

                case 7:
                  _this.loadScripts();

                  _context.next = 13;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](0);

                  _this.setState({
                    error: _context.t0.message
                  });

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 10]]);
        }))
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "openConfirmArchiveModal", (0, _lodash.default)(function (_ref4) {
      var scriptId = _ref4.scriptId,
          name = _ref4.name;
      return function () {
        _this.setState({
          modalOpened: MODAL.ARCHIVE,
          scriptId: scriptId,
          name: name || 'New Script'
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "loadScripts", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, getScripts, getArchivedScripts, archivedFilter, loadScriptsRequest, scriptsField, _ref6, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, getScripts = _this$props.getScripts, getArchivedScripts = _this$props.getArchivedScripts;
              archivedFilter = _this.state.archivedFilter;
              _context2.prev = 2;
              loadScriptsRequest = archivedFilter === 'ARCHIVED' ? getArchivedScripts : getScripts;
              scriptsField = archivedFilter === 'ARCHIVED' ? 'getArchivedScripts' : 'getScripts';
              _context2.next = 7;
              return loadScriptsRequest();

            case 7:
              _ref6 = _context2.sent;
              data = _ref6.data;
              error = _ref6.error;

              _this.setState({
                loading: false
              });

              if (!error) {
                _context2.next = 13;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                error: error
              }));

            case 13:
              _this.setState({
                scripts: data[scriptsField]
              });

              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](2);

              _this.setState({
                error: _context2.t0.message
              });

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 16]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "gotoScript", function (scriptId) {
      return function () {
        var history = _this.props.history;
        history.push("edit/".concat(scriptId));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleCreateScript", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var createScript, _ref8, data, error;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              createScript = _this.props.createScript;
              _context3.prev = 1;

              _this.setState({
                creating: true
              });

              _context3.next = 5;
              return createScript();

            case 5:
              _ref8 = _context3.sent;
              data = _ref8.data;
              error = _ref8.error;

              _this.setState({
                creating: false
              });

              if (!error) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", void _this.setState({
                error: error
              }));

            case 11:
              _this.gotoScript(data.createScript.scriptId)();

              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](1);

              _this.setState({
                error: _context3.t0.message,
                creating: false
              });

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 14]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleDeleteScript", function (scriptId, name) {
      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this.setState({
                    modalOpened: MODAL.DELETE,
                    scriptId: scriptId,
                    name: name || 'New Script'
                  });

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "onArchive", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _this$props2, archiveScript, unarchiveScript, _this$state, scriptId, name, archivedFilter, showArchived, action, actionRequest, _ref11, error;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$props2 = _this.props, archiveScript = _this$props2.archiveScript, unarchiveScript = _this$props2.unarchiveScript;
              _this$state = _this.state, scriptId = _this$state.scriptId, name = _this$state.name, archivedFilter = _this$state.archivedFilter;
              showArchived = archivedFilter === 'ARCHIVED';
              action = showArchived ? 'unarchived' : 'archived';
              actionRequest = showArchived ? unarchiveScript : archiveScript;
              _context5.next = 7;
              return actionRequest(scriptId);

            case 7:
              _ref11 = _context5.sent;
              error = _ref11.error;

              if (!error) {
                _context5.next = 11;
                break;
              }

              return _context5.abrupt("return", void _this.setState({
                error: error
              }));

            case 11:
              _this.setState({
                modalOpened: void 0
              }, function () {
                (0, _commonReact.notify)({
                  content: "".concat(name, " successfully ").concat(action),
                  type: 'success'
                });

                _this.loadScripts();
              });

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleFilterChange", function (_ref12) {
      var ARCHIVED_FILTER = _ref12.filters.ARCHIVED_FILTER,
          searchTerm = _ref12.searchTerm;
      var archivedFilter = _this.state.archivedFilter;

      if (archivedFilter === ARCHIVED_FILTER) {
        return void _this.setState({
          searchTerm: searchTerm
        });
      }

      _this.setState({
        searchTerm: searchTerm,
        archivedFilter: ARCHIVED_FILTER
      }, function () {
        return _this.loadScripts();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFilteredScripts", function () {
      var _this$state2 = _this.state,
          _this$state2$scripts = _this$state2.scripts,
          scripts = _this$state2$scripts === void 0 ? [] : _this$state2$scripts,
          searchTerm = _this$state2.searchTerm;

      if (!searchTerm) {
        return scripts;
      }

      return scripts.filter(function (item) {
        return Object.values(item).some(function (dataField) {
          return dataField && typeof dataField === 'string' && dataField.toLowerCase().includes(searchTerm.toLowerCase());
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onComplete", function () {
      var name = _this.state.name;

      _this.setState({
        modalOpened: void 0
      }, function () {
        (0, _commonReact.notify)({
          content: "".concat(name, " successfully deleted"),
          type: 'success'
        });

        _this.loadScripts();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideModal", function () {
      _this.setState({
        modalOpened: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (_ref13) {
      var scriptId = _ref13.scriptId,
          name = _ref13.name,
          updatedAt = _ref13.updatedAt,
          resourcePermissions = _ref13.permissions;
      var duplicateScript = _this.props.duplicateScript;
      var archivedFilter = _this.state.archivedFilter;
      var actionOptions = [{
        action: _this.gotoScript(scriptId),
        label: 'EDIT SCRIPT',
        requiredPermission: 'READ'
      }, {
        action: _this.handleScriptAction({
          actionRequest: duplicateScript,
          scriptId: scriptId
        }),
        label: 'DUPLICATE',
        requiredPermission: 'READ'
      }, {
        action: _this.openConfirmArchiveModal({
          scriptId: scriptId,
          name: name
        }),
        label: archivedFilter === 'ARCHIVED' ? 'UNARCHIVE' : 'ARCHIVE',
        requiredPermission: 'ARCHIVE'
      }, {
        action: _this.handleDeleteScript(scriptId, name),
        label: 'DELETE',
        isRed: true,
        requiredPermission: 'DELETE'
      }];
      return _react.default.createElement(_uiKit.List.ListItem, {
        onClick: _this.gotoScript(scriptId),
        key: "script-list-".concat(scriptId),
        actionPopupOptions: actionOptions.filter(function (_ref14) {
          var requiredPermission = _ref14.requiredPermission;
          return (0, _commonReact.hasPermission)(requiredPermission, resourcePermissions);
        }),
        resourcePermissions: resourcePermissions,
        defaultImageIcon: "script"
      }, _react.default.createElement("div", {
        className: "list-item__name"
      }, _react.default.createElement("h3", {
        className: "list-item__name__text"
      }, name || 'New Script')), _react.default.createElement("div", {
        className: "list-item__timestamp"
      }, _react.default.createElement("p", {
        className: "list-item__timestamp__text"
      }, _react.default.createElement("strong", null, " ".concat((0, _moment.default)(updatedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('DD MMM YYYY'), " at ").concat((0, _moment.default)(updatedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('h:mma z')))), _react.default.createElement("p", {
        className: "list-item__timestamp__text"
      }, "Last Updated")));
    });

    _defineProperty(_assertThisInitialized(_this), "scriptCard", function (_ref15) {
      var scriptId = _ref15.scriptId,
          name = _ref15.name,
          content = _ref15.content;
      return _react.default.createElement("div", {
        tabIndex: 0,
        role: "button",
        onKeyDown: _this.gotoScript(scriptId),
        className: "scripts__card",
        key: "script-card-".concat(scriptId),
        onClick: _this.gotoScript(scriptId)
      }, _react.default.createElement("div", null, _react.default.createElement("h2", {
        className: "scripts__card__name"
      }, name || 'New Script'), _react.default.createElement("p", {
        className: "scripts__card__content"
      }, content)));
    });

    _this.state = {
      searchTerm: '',
      archivedFilter: '',
      creating: false,
      loading: true,
      modalOpened: '',
      name: ''
    };
    return _this;
  }

  _createClass(Scripts, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadScripts();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevOrganisationId = prevProps.organisationId;
      var organisationId = this.props.organisationId;

      if (prevOrganisationId === organisationId) {
        return;
      }

      this.loadScripts();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          history = _this$props3.history,
          organisationName = _this$props3.organisationName,
          deleteScript = _this$props3.deleteScript;
      var _this$state3 = this.state,
          scripts = _this$state3.scripts,
          creating = _this$state3.creating,
          loading = _this$state3.loading,
          error = _this$state3.error,
          modalOpened = _this$state3.modalOpened,
          archivedFilter = _this$state3.archivedFilter,
          scriptId = _this$state3.scriptId,
          name = _this$state3.name;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      return _react.default.createElement("div", {
        className: "scripts page"
      }, _react.default.createElement(_uiKit.PageHeader, {
        title: "Scripts",
        subtitle: organisationName,
        actionBtnText: "Create New Script",
        actionBtnOnClick: this.handleCreateScript,
        actionBtnBusy: creating
      }), _react.default.createElement("div", {
        className: "page__content"
      }, _react.default.createElement(_uiKit.RecentList, {
        onCreate: this.handleCreateScript,
        onCreateText: "Create New Script",
        data: scripts,
        renderElement: this.scriptCard,
        listKey: "scriptId"
      }), _react.default.createElement(_uiKit.List, {
        loading: loading,
        history: history,
        data: this.getFilteredScripts(),
        filters: LIST_FILTERS,
        onFiltersChange: this.handleFilterChange,
        renderListItem: this.renderListItem,
        listKey: "scriptId"
      }), _react.default.createElement(_commonReact.ConfirmationModal, {
        title: "Are you sure?",
        subtitle: getArchiveModalSubtitle(archivedFilter, organisationName),
        visible: scriptId && modalOpened === MODAL.ARCHIVE,
        onClose: this.hideModal,
        onSave: this.onArchive
      }), modalOpened === MODAL.DELETE && _react.default.createElement(_commonReact.DeleteConfirmationModal, {
        onDelete: deleteScript,
        objectId: scriptId,
        hideModal: this.hideModal,
        onComplete: this.onComplete,
        title: "Delete ".concat(name, "?"),
        subTitle: "Are you sure you want to delete ".concat(name, "?")
      })));
    }
  }]);

  return Scripts;
}(_react.Component);

var _default = Scripts;
exports.default = _default;